// extracted by mini-css-extract-plugin
module.exports = {"CommentListContainer":"CommentListContainer_vvHQq","CardSectionContainer":"CardSectionContainer_fpIwf","CommentCard":"CommentCard_NvrcH","GreenColor":"GreenColor_ogO-Q"};